import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

export const RoleGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const allowedRoles = (route.data['roles'] as string[] | undefined) ?? [];
  const userRole = auth.getRole();

  // si no definiste roles en la ruta, dejamos pasar
  if (allowedRoles.length === 0) return true;

  if (userRole && allowedRoles.includes(userRole)) return true;

  return router.createUrlTree(['/home']); // o '/login'
};
